import { render } from "./TestimonioFeedbackNew.vue?vue&type=template&id=a4ae7502&scoped=true"
import script from "./TestimonioFeedbackNew.vue?vue&type=script&lang=js"
export * from "./TestimonioFeedbackNew.vue?vue&type=script&lang=js"

import "./TestimonioFeedbackNew.vue?vue&type=style&index=0&id=a4ae7502&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4ae7502"]])

export default __exports__